export const getters = {
  programList: state => state.program,
  workoutSchedules: state => state.workoutSchedules
};
